import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles, { type ClassNames } from "./themes-2026.module.scss";

export type Theme = ClassNames;

interface Themable {
    theme?: Theme | null;
    tag?: keyof React.JSX.IntrinsicElements;
}

export const Themed = React.forwardRef<
    HTMLElement,
    Themable & React.HTMLAttributes<HTMLElement>
>(({ theme, tag: Tag = "div", ...props }, ref) => {
    return React.createElement(Tag, {
        ...props,
        className: concatClassNames([
            theme ? styles[theme] : undefined,
            props.className,
        ]),
        ref,
    });
});
